<template>
  <div class="increase-edit-padding">
    <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
      <!-- 角色名称 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Role Name"
        hasFeedback
      >
        <a-input
          placeholder="Role Name"
          v-decorator="[
            'name',
            {rules: [{ required: true, message: 'Please input role name' }]}
          ]"
        ></a-input>
      </a-form-item>
      <!-- 角色代码 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Role Code"
        hasFeedback
      >
        <a-input
          placeholder="Role Code"
          v-decorator="[
            'code',
            {rules: [{ required: true, message: 'Please input role code' }]}
          ]"
        ></a-input>
      </a-form-item>
      <!-- 序号 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Sort Number"
        hasFeedBack
      >
        <a-input-number
          placeholder="Sort Number"
          v-decorator="[
            'sortNum',
            {rules: [{ required: true, message: 'Please input sort number.' }]}
          ]"
        ></a-input-number>
      </a-form-item>
      <!-- 启用状态 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Enabled"
        hasFeedBack
      >
        <a-switch v-decorator="['enabledSwitch', { valuePropName: 'checked' }]" />
      </a-form-item>
      <!-- 隐藏域 -->
      <a-form-item v-show="false"><a-input v-decorator="['id']"/></a-form-item>
      <!-- 拥有权限 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Has Permisions"
      >
        <a-spin :spinning="permissionTreeLoagding" tip="Loading...">
          <a-tree
            checkable
            v-model="checkedPermissionKeys"
            :treeData="permissionTreeNodeData"
          />
        </a-spin>
      </a-form-item>
      <a-form-item v-bind="buttonCol">
        <a-row class="btn-box btn-left">
          <a-button type="primary" html-type="submit">Save</a-button>
          <a-button style="margin-left: 8px;" @click="handleGoBack">Cancel</a-button>
        </a-row>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import { queryPermissionTree } from '@/api/api-permission'
import { addRole, updateRole, getRoleDetail } from '@/api/api-role'

export default {
  name: 'RoleEdit',
  props: {
    record: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      id: 0,
      // 选中权限
      checkedPermissionKeys: [],
      // 权限树结构数据
      permissionData: null,
      // 节点树loading状态
      permissionTreeLoagding: true
    }
  },
  // beforeCreate () {
  //   this.form = this.$form.createForm(this)
  // },
  mounted () {
    this.$nextTick(() => {
      this.loadEditInfo(this.record)
      this.loadPermissionTree()
    })
  },
  methods: {
    loadPermissionTree () {
      // 查询已启用的节点树
      this.permissionTreeLoagding = true
      queryPermissionTree({ 'enabledFlag': '1' }).then(res => {
        this.permissionData = res.data
        this.permissionTreeLoagding = false
        if (this.record !== '') {
          this.loadRoleDetail(this.record.id)
        }
      })
    },
    // 读取角色详情
    loadRoleDetail (id) {
      this.permissionTreeLoagding = true
      getRoleDetail(id).then(res => {
        const role = res.data
        const permissions = role.permissions
        if (permissions && permissions.length > 0) {
          const ids = permissions.map(t => t.id)
          console.debug('permissions', ids)
          this.checkedPermissionKeys = ids
        }
        this.permissionTreeLoagding = false
      })
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit (e) {
      e.preventDefault()
      console.debug('checkedPermissionKeys', this.checkedPermissionKeys)
      // eslint-disable-next-line
      this.editForm.validateFields((err, fieldsValue) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = this.editForm.getFieldsValue()
        formData.enabledFlag = formData.enabledSwitch ? '1' : '0'
        formData.permissionIdList = this.checkedPermissionKeys
        // 添加
        if (formData.id === null) {
          addRole(formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Role save successfully !')
              this.handleGoBack()
            }
          })
        }
        // 修改
        if (formData.id !== null) {
          updateRole(formData.id, formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Role update successfully !')
              this.handleGoBack()
            }
          })
        }
      })
    },
    loadEditInfo (data) {
      var formData = null
      if (data === '') {
        // 新增
        formData = { 'id': null, 'enabledSwitch': true, 'sortNum': 1 }
      } else {
        // 编辑
        formData = pick(data, ['id', 'name', 'code', 'sortNum'])
        // 状态切换
        formData.enabledSwitch = data.enabledFlag === '1'
      }
      console.debug('formData', formData)
      this.editForm.setFieldsValue(formData)
    }
  },
  computed: {
    // 所有权限选项列表
    permissionTreeNodeData () {
      if (this.permissionData && this.permissionData.length > 0) {
        const treeData = this.permissionData.map(d1 => {
          var t1 = { title: d1.name, key: d1.id }
          if (d1.subPermission && d1.subPermission.length > 0) {
            t1.children = d1.subPermission.map(d2 => {
              var t2 = { title: d2.name, key: d2.id }
              if (d2.subPermission && d2.subPermission.length > 0) {
                t2.children = d2.subPermission.map(d3 => {
                  return { title: d3.name, key: d3.id }
                })
              }
              return t2
            })
          }
          return t1
        })
        return treeData
      }
      return []
    }
  }
}
</script>
